<template>
    <div class="page-content">
        <!--    页面标题 start -->
        <div v-web-title data-title="常住人"></div>
        <!--    页面标题 end -->

        <Row type="flex" justify="center">
            <!--        侧边栏 start -->
            <i-col :lg="4">

                <SideBar class="mobile-no-sidebar" />

            </i-col>
            <!--        侧边栏 end -->

            <!--            常住人列表 start-->
            <i-col :xs="24" :md="24" :lg="12">

                <GuestList />

            </i-col>
            <!--            常住人列表 end-->

        </Row>

    </div>
</template>

<script>
  import SideBar from "../../components/SideBar/SideBar";
  import GuestList from "../../components/guestList/GuestList";
  export default {
    name: "Guest",
    components: {GuestList, SideBar}
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "Guest.scss";

</style>
